import { ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";

export class PageOverview extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = props.pageData; //safeClone(props.pageData);

    //console.log("PROPS OVERVIEW DATA IS ",props.data);
    props.class = "app-page";
    props.id = "l1-Overview";
    //props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    props.template = require("./templates/page.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {
    this.page$CheckToAddCards();
    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();
  }
}
